import { render } from "./viewDealerInfo.vue?vue&type=template&id=15884c8b&scoped=true"
import script from "./viewDealerInfo.vue?vue&type=script&lang=js"
export * from "./viewDealerInfo.vue?vue&type=script&lang=js"

import "./viewDealerInfo.vue?vue&type=style&index=0&id=15884c8b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15884c8b"]])

export default __exports__